import React, { useState } from "react";
import ChecklistCard from "../../ChecklistCard.js";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import FormControl from "@mui/material/FormControl";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import MultiRepCard from "../../MultiRepCard.js";
import MustRefer from "../../MustRefer.js";
import ClauseCard from "../../ClauseCard.js";
import clauseData from "../../../data/Newfoundland/clauseData.js";
import clauseCardDesc from "../../../data/Newfoundland/clauseCardDescription.js";
import importantNotes from "../../../data/Newfoundland/importantNotes.js";
import ImportantNotes from "../../ImportantNotes.js";
import BackToTop from "../../BackToTop.js";

export default function AssignmentPurchase() {
  const [BuyerDocs, setBuyerDocs] = useState([
    "RECO Info Guide Acknowledgement",
    "Buyer Representation Agreement with Schedule A (371)",
    "Related FINTRAC Documents",
  ]);

  const [DealDocs, setDealDocs] = useState([
    "Assignment of Agreement of Purchase & Sale (145 or 150)",
    "Original Purchase Agreement (Schedule C)",
    "Schedule B1 (if eXp holding deposit)",
    "Confirmation of Co-operation (320)",
    "Copy of Deposit & Receipt",
    "Full REALTOR® SOLD MLS Printout",
  ]);

  const [SellerRep, setSellerRep] = useState("No");
  const [IsDisclosure, setIsDisclosure] = useState("No");
  const [ListingType, setListingType] = useState("MLS");
  const [BuyerRep, setBuyerRep] = useState("Client");

  const theme = createTheme({
    palette: {
      primary: {
        main: "#506CAA",
        dark: "#506CAA",
      },
      text: {
        primary: "#31303F",
        secondary: "#506CAA",
      },
    },
  });

  const addDisclosure = (e) => {
    setIsDisclosure("Yes");
    if (
      DealDocs.includes("Registrant's Disclosure of Interest (160 or 161)") ===
      true
    ) {
      return;
    } else {
      setDealDocs([
        ...DealDocs,
        "Registrant's Disclosure of Interest (160 or 161)",
      ]);
    }
  };

  const removeDisclosure = (e) => {
    setIsDisclosure("No");
    setDealDocs(
      DealDocs.filter(
        (item) => item !== "Registrant's Disclosure of Interest (160 or 161)"
      )
    );
  };

  const setExclusive = (e) => {
    setListingType(e.target.value);
    setDealDocs(
      DealDocs.filter((item) => item !== "Full REALTOR® SOLD MLS Printout")
    );
  };

  const setMLS = (e) => {
    setListingType(e.target.value);
    if (DealDocs.includes("Full REALTOR® SOLD MLS Printout") === true) {
      return;
    } else {
      setDealDocs([...DealDocs, "Full REALTOR® SOLD MLS Printout"]);
    }
  };

  const handleSellerRep = (e) => {
    setSellerRep(e.target.value);
    if (e.target.value === "Yes") {
      setListingType("MLS");
      if (DealDocs.includes("Full REALTOR® SOLD MLS Printout") === true) {
        return;
      } else {
        setDealDocs([...DealDocs, "Full REALTOR® SOLD MLS Printout"]);
      }
    }
    if (e.target.value === "No") {
      setBuyerRep("Client");
      setBuyerDocs([
        "RECO Info Guide Acknowledgement",
        "Buyer Representation Agreement with Schedule A (371)",
        "Related FINTRAC Documents",
      ]);
    }
  };

  const handleBuyerRep = (e) => {
    setBuyerRep(e.target.value);
    if (e.target.value === "Client") {
      setBuyerDocs([
        "RECO Info Guide Acknowledgement",
        "Buyer Representation Agreement with Schedule A (371)",
        "Related FINTRAC Documents",
      ]);
    } else {
      setBuyerDocs([
        "RECO Info Guide Acknowledgement",
        "RECO Self-Represented Disclosure Form",
        "Related FINTRAC Documents",
      ]);
    }
  };

  return (
    <div className="checklists w-full flex flex-col items-center justify-center">
      <div className="flex flex-col w-full pl-4 ">
        <div className="flex flex-col items-left pb-2">
          <div className="pr-5 pt-3">
            Do you also represent the Assignor (Seller) in this transaction?
          </div>
          <ThemeProvider theme={theme}>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                defaultValue="No"
              >
                <FormControlLabel
                  value="Yes"
                  control={<Radio size="small" onClick={handleSellerRep} />}
                  label="Yes"
                />
                <FormControlLabel
                  value="No"
                  control={<Radio size="small" onClick={handleSellerRep} />}
                  label="No"
                />
              </RadioGroup>
            </FormControl>
          </ThemeProvider>
          {SellerRep === "Yes" ? (
            <>
              <div className="pr-5 pt-5">
                Assignee's (Buyer) Representation Choice?
              </div>
              <ThemeProvider theme={theme}>
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    defaultValue="Client"
                    value={BuyerRep}
                  >
                    <FormControlLabel
                      value="Client"
                      control={<Radio size="small" onClick={handleBuyerRep} />}
                      label="Client"
                    />
                    <FormControlLabel
                      value="SRP"
                      control={<Radio size="small" onClick={handleBuyerRep} />}
                      label="Self-Represented Party"
                    />
                  </RadioGroup>
                </FormControl>
              </ThemeProvider>
            </>
          ) : (
            ""
          )}
          <div className="pr-5 pt-5">Type of Listing?</div>
          <ThemeProvider theme={theme}>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                value={ListingType}
                defaultValue="MLS"
              >
                <FormControlLabel
                  value="MLS"
                  control={<Radio size="small" onClick={setMLS} />}
                  label="MLS"
                />
                <FormControlLabel
                  value="Exclusive"
                  control={<Radio size="small" onClick={setExclusive} />}
                  label="Exclusive"
                />
                {SellerRep === "No" ? (
                  <FormControlLabel
                    value="Mere"
                    control={<Radio size="small" onClick={setMLS} />}
                    label="Mere Posting"
                  />
                ) : (
                  ""
                )}
              </RadioGroup>
            </FormControl>
          </ThemeProvider>
          <div className="pr-5 pt-5">
            {SellerRep === "Yes"
              ? `Are you or any of your close relatives the Assignor or the Assignee?`
              : `Are you or close relatives purchasing this Agreement?`}
          </div>
          <ThemeProvider theme={theme}>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                defaultValue="No"
              >
                <FormControlLabel
                  value="Yes"
                  control={<Radio size="small" onClick={addDisclosure} />}
                  label="Yes"
                />
                <FormControlLabel
                  value="No"
                  control={<Radio size="small" onClick={removeDisclosure} />}
                  label="No"
                />
              </RadioGroup>
            </FormControl>
          </ThemeProvider>
        </div>
      </div>
      {ListingType === "Mere" ? (
        <>
          <div className="paragraph ml-5 mr-3">
            <p>
              <strong>Important:</strong> Even though the listing brokerage is
              providing less services, they still have a representation
              agreement with the Assignor (Seller). For the deposit, eXp should
              hold as the listing brokerage typically will not.
              <br />
              <br />
              <strong>FORM 320: </strong>Please ensure commission is clearly
              defined on FORM 320. In the commission section of FORM 320, check
              4b-2 and put{" "}
              <em>
                "[the commission amount] as per the remuneration clause in the
                agreement"
              </em>
              . Make sure you include a Remuneration Clause in the Assignment of
              the Agreement of Purchase & Sale to cover the agreed upon
              commission. It is common for the listing brokerage to decline
              signing this form. Be sure to have the other parties sign.
              <br />
              <br />
              <strong>
                Remuneration Clause:
                <br />
              </strong>
              The Assignee directs the Assignor and the Assignor agrees to pay
              the Assignee's closing credit equal to _____ of the Purchase
              Price, plus applicable Harmonized Sales Tax (HST), to the
              Assignee's Brokerage, eXp Realty, at the closing of the
              transaction by the Assignor's lawyer/representative. This payment
              is to be made to satisfy the Assignee's Buyer Representation
              Agreement (BRA) with eXp Realty, Brokerage.
            </p>
          </div>
        </>
      ) : (
        ""
      )}

      {SellerRep === "No" ? (
        <ChecklistCard
          province={"NL"}
          CheckListData={BuyerDocs}
          CheckListData2={DealDocs}
          Header={"Purchase:"}
          Header2={"Assignee Client (New Buyer)"}
          Title1="Assignee (Buyer) Representation Documents"
          Title2="Deal Documents"
        />
      ) : (
        ""
      )}

      {SellerRep === "Yes" ? (
        <>
          {IsDisclosure === "Yes" && BuyerRep === "Client" ? (
            <MustRefer IsMLS={ListingType} />
          ) : (
            ""
          )}
          {BuyerRep === "Client" && IsDisclosure === "No" ? (
            <>
              <MultiRepCard />
              <ChecklistCard
                province={"NL"}
                CheckListData={BuyerDocs}
                CheckListData2={DealDocs}
                Header={"Purchase:"}
                Header2={"Assignee Client (New Buyer)"}
                Title1="Assignee (Buyer) Representation Documents"
                Title2="Deal Documents"
              />
            </>
          ) : (
            ""
          )}
        </>
      ) : (
        ""
      )}

      {BuyerRep === "SRP" ? (
        <ChecklistCard
          province={"NL"}
          CheckListData={BuyerDocs}
          CheckListData2={DealDocs}
          Header={"Purchase:"}
          Header2={"Assignee is a SRP"}
          Title1="Assignee (Buyer) Documents"
          Title2="Deal Documents"
        />
      ) : (
        ""
      )}

      {SellerRep === "Yes" &&
      BuyerRep === "Client" &&
      IsDisclosure === "Yes" ? (
        ""
      ) : ListingType === "Mere" ? (
        <ClauseCard
          ClauseCardDescription={clauseCardDesc.filter((item) =>
            item.category.includes("assign")
          )}
          ClauseDataCommon={clauseData.filter(
            (item) =>
              item.category.includes("assignmere") && item.isCommon === "yes"
          )}
          ClauseDataSituational={clauseData.filter(
            (item) =>
              item.category.includes("assignmere") && item.isCommon === "no"
          )}
          PurchaseType="Assignment"
        />
      ) : (
        <ClauseCard
          ClauseCardDescription={clauseCardDesc.filter((item) =>
            item.category.includes("assign")
          )}
          ClauseDataCommon={clauseData.filter(
            (item) =>
              item.category.includes("assign") && item.isCommon === "yes"
          )}
          ClauseDataSituational={clauseData.filter(
            (item) => item.category.includes("assign") && item.isCommon === "no"
          )}
          PurchaseType="Assignment"
        />
      )}

      <div className="important-notes flex flex-col w-full justify-left pt-6">
        <strong>Important Notes:</strong>
        <div className="pb-3"></div>
        {IsDisclosure === "Yes" ? (
          <ImportantNotes
            Notes={importantNotes.filter(
              (notes) => notes.category.includes("disclosure") === true
            )}
          />
        ) : (
          ""
        )}
        <ImportantNotes
          Notes={importantNotes.filter(
            (notes) => notes.category.includes("assignPurchase") === true
          )}
        />
      </div>
      <BackToTop />
    </div>
  );
}
